import { type HandledError, handleQueryError } from '@/shared/utils/helpers/handle-query-error';

import type { TCustomError } from '@/shared';

export const handleConversionPairError = (error?: HandledError): TCustomError | undefined => {
  const queryError = handleQueryError(error);

  if (queryError) {
    if (typeof queryError === 'string') {
      return {
        root: queryError,
      };
    }

    const { detail } = queryError;

    if (typeof detail === 'string') {
      return {
        root: detail,
      };
    }

    if (Array.isArray(detail)) {
      return {
        root: detail.map((item) => item.msg).join('. '),
      };
    }

    return {
      root: 'Unknown error',
    };
  }
};
